export default "__VITE_ASSET__DuKCuDtu__"